import { Codebook } from '../Codebook'
import { $t } from '../../composables/i18n'
import { Color } from '../color/Color'
import { StringUtils } from '../../utils/String'

export enum ReservationStatusId {
  OPTION = 1,
  CONFIRMED = 2,
  CHECKED_IN = 3,
  WAITING_LIST = 6,
  CANCELLED = 7,
  NO_SHOW = 8,
  CHECKED_OUT = 9,
  OTHER = 10,
}

export class ReservationStatus extends Codebook<ReservationStatusId> {
  private constructor(
    id: ReservationStatusId,
    public readonly name: () => string,
    public readonly color: Color,
    public readonly icon: null | string,
    public readonly isActive: boolean,
    public readonly isCancelled: boolean,
  ) {
    super(id)
  }

  static readonly OPTION = new ReservationStatus(
    ReservationStatusId.OPTION,
    () => $t('option'),
    Color.RES_OPTION,
    null,
    true,
    false,
  )
  static readonly CONFIRMED = new ReservationStatus(
    ReservationStatusId.CONFIRMED,
    () => $t('confirmed'),
    Color.RES_CONFIRMED,
    null,
    true,
    false,
  )
  static readonly CHECKED_IN = new ReservationStatus(
    ReservationStatusId.CHECKED_IN,
    () => $t('checked-in'),
    Color.RES_CHECKED_IN,
    null,
    true,
    false,
  )
  static readonly CHECKED_OUT = new ReservationStatus(
    ReservationStatusId.CHECKED_OUT,
    () => $t('checked-out'),
    Color.RES_CHECKED_OUT,
    null,
    true,
    false,
  )
  static readonly OTHER = new ReservationStatus(
    ReservationStatusId.OTHER,
    () => $t('other'),
    Color.RES_OTHER,
    null,
    true,
    false,
  )
  static readonly CANCELLED = new ReservationStatus(
    ReservationStatusId.CANCELLED,
    () => $t('cancelled'),
    Color.RES_CANCELED,
    'ban',
    false,
    true,
  )
  static readonly WAITING_LIST = new ReservationStatus(
    ReservationStatusId.WAITING_LIST,
    () => $t('waiting list'),
    Color.RES_WAITING_LIST,
    'hourglass-end',
    false,
    false,
  )
  static readonly NO_SHOW = new ReservationStatus(
    ReservationStatusId.NO_SHOW,
    () => $t('no-show'),
    Color.RES_NO_SHOW,
    'eye-slash',
    false,
    true,
  )

  public nameCapitalize(): string {
    return StringUtils.capitalize(this.name())
  }

  static canvasStatuses = (): ReservationStatus[] => {
    return [
      ReservationStatus.OPTION,
      ReservationStatus.CONFIRMED,
      ReservationStatus.CHECKED_IN,
      ReservationStatus.CHECKED_OUT,
      ReservationStatus.OTHER,
    ]
  }
}
